module.exports = __webpack_public_path__ + "static/media/cult-frame.cac62a40.png";